import { render, staticRenderFns } from "./Obi.vue?vue&type=template&id=c258d7d0&"
import script from "./Obi.vue?vue&type=script&lang=js&"
export * from "./Obi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports